import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useCafeAuth } from "../auth/CafeAuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { CafeShell, Field, inputStyle } from "./CafeShell";

export default function CafeLoginPage() {
  const { login } = useCafeAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSubmitting(true);
    try {
      await login(email, password);
      navigate("/cafe/dashboard", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <CafeShell testId="cafe-login-page">
      <h2 className="italic-quote" style={{ fontSize: 28, color: "var(--cream)", textAlign: "center", margin: "0 0 30px" }}>
        Cafe partner sign-in
      </h2>
      <form onSubmit={handleSubmit}>
        <Field label="Email">
          <input data-testid="login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} />
        </Field>
        <Field label="Password">
          <input data-testid="login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} style={inputStyle} />
        </Field>
        {error && <p data-testid="login-error" className="error-banner" style={{ marginBottom: 16 }}>{error}</p>}
        <button data-testid="login-submit" className="primary-btn" disabled={submitting} type="submit">
          {submitting ? "Signing in…" : "Sign in"}
        </button>
        <p className="body-copy" style={{ textAlign: "center", marginTop: 18, fontSize: 13 }}>
          New partner? <Link to="/cafe/signup" data-testid="login-to-signup" style={{ color: "var(--gold)", textDecoration: "underline" }}>Create your partner page</Link>
        </p>
        <p className="body-copy" style={{ textAlign: "center", marginTop: 10, fontSize: 13 }}>
          Curious first? <Link to="/begin" data-testid="login-to-begin" style={{ color: "var(--gold)", textDecoration: "underline" }}>Apply for the Beta ✦</Link>
        </p>
      </form>
    </CafeShell>
  );
}
